export const COLLECTIONS = {
  users: "users",
  classSessions: "classSessions",
  posts: "posts",
  postLikes: "postLikes",
  events: "events",
  opportunities: "opportunities",
  conversations: "conversations",
  challenges: "challenges",
  challengeSubmissions: "submissions",
  challengeSubmissionLoves: "challengeSubmissionLoves",
  analyticsEvents: "analyticsEvents",
  nextParticipationAnalyticsEvents: "nextParticipationAnalyticsEvents",
  peerShoutOuts: "peerShoutOuts",
  follows: "follows",
  notifications: "notifications",
  coachAffiliations: "coachAffiliations",
  coachEarnings: "coach_earnings",
  coachEarningAdjustments: "coach_earning_adjustments",
  coachPayouts: "coach_payouts",
  coachMetrics: "coach_metrics",
  founderFinanceOperatingCosts: "founderFinanceOperatingCosts",
  marketplaceTransactions: "marketplace_transactions",
  eventTickets: "eventTickets",
  stripeWebhookEvents: "stripe_webhook_events",
  bookings: "bookings",
  subscriptions: "subscriptions",
  boostTransactions: "boostTransactions",
  guidedJourneyItems: "guidedJourneyItems",
  nextMoveRecommendations: "nextMoveRecommendations",
  userSkillSummaries: "userSkillSummaries",
  routineAssignments: "routineAssignments",
  reports: "reports",
  flaggedContent: "flaggedContent",
  reportedMessages: "reportedMessages",
  postFeedback: "postFeedback",
  verificationRequests: "verificationRequests",
  betaFeedbackReports: "betaFeedbackReports",
  guardianApprovals: "guardianApprovals",
  guardianLinks: "guardianLinks",
  founderJournalEntries: "founderJournalEntries"
} as const;

export const ADMIN_ANALYTICS_COLLECTION = "adminAnalytics";

export const ADMIN_ANALYTICS_DOCS = {
  dau: "dau",
  wau: "wau",
  mau: "mau",
  revenueToday: "revenueToday",
  revenueWeek: "revenueWeek",
  revenueMonth: "revenueMonth",
  revenueTrends: "revenueTrends",
  userGrowth: "userGrowth",
  retention: "retention",
  coachEarningsSummaries: "coachEarningsSummaries",
  platformHealthMetrics: "platformHealthMetrics"
} as const;

export const UNKNOWN_COLLECTION_TODOS = [
  "No dedicated admin system-health collection was found; system health currently reads existing moderation/report/verification collections.",
  "No dedicated revenue rollup collection was found; revenue currently reads existing transaction, booking, earnings, payout, subscription, and boost collections.",
  "No dedicated coach directory collection was found; coaches currently derive from users plus existing coach metrics/affiliations collections.",
  "No active sessions collection was found; active sessions should be wired when session tracking exists.",
  "No failed signups collection was found; failed signup visibility should come from a future auth/signup failure aggregate."
];
